// Escape utility — turns invisible/bidi/tag chars into ⟦U+NNNN⟧ markers.
// Used by RawTextViewer. NEVER call dangerouslySetInnerHTML with its output —
// it's for `textContent` only.

const INVISIBLE = new Set([
  "\u200B", "\u200C", "\u200D", "\uFEFF", "\u00AD",
]);

function isBidiOrTag(cp) {
  return (cp >= 0x202A && cp <= 0x202E) ||
         (cp >= 0x2066 && cp <= 0x2069) ||
         (cp >= 0xE0000 && cp <= 0xE007F);
}

export function escapeInvisibles(text) {
  if (!text) return "";
  const out = [];
  for (const ch of text) {
    const cp = ch.codePointAt(0);
    if (INVISIBLE.has(ch) || isBidiOrTag(cp)) {
      out.push(`\u27E6U+${cp.toString(16).toUpperCase().padStart(4, "0")}\u27E7`);
    } else {
      out.push(ch);
    }
  }
  return out.join("");
}

// Split a marked string into [{text, match?}] pieces around rule-match positions.
// Positions reference the ORIGINAL (unmarked) text; the server has already applied
// markers so matches may be offset — we therefore highlight by substring, not index.
export function splitByMatches(markedText, matches) {
  if (!markedText) return [];
  const seen = new Set();
  const needles = [];
  for (const m of matches || []) {
    const needle = (m.evidence_excerpt || "").slice(0, 80).trim();
    if (needle && !seen.has(needle)) {
      seen.add(needle);
      needles.push({ needle, meta: m });
    }
  }
  const spans = [{ text: markedText }];
  for (const { needle, meta } of needles) {
    for (let i = 0; i < spans.length; i++) {
      const span = spans[i];
      if (span.match || !span.text.includes(needle)) continue;
      const idx = span.text.indexOf(needle);
      const before = span.text.slice(0, idx);
      const hit = span.text.slice(idx, idx + needle.length);
      const after = span.text.slice(idx + needle.length);
      const replacement = [];
      if (before) replacement.push({ text: before });
      replacement.push({ text: hit, match: meta });
      if (after) replacement.push({ text: after });
      spans.splice(i, 1, ...replacement);
      break;
    }
  }
  return spans;
}
